/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioTipoContribuyenteCV from './controladorVista/formularioTipoContribuyenteCV';
import TablaTipoContribuyenteCV from './controladorVista/tablaTipoContribuyenteCV';
import { estadoIncial, reductor } from './reductorTipoContribuyente';

const TipoContribuyente: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTipoContribuyenteCV />
        <FormualrioTipoContribuyenteCV />
    </ProveedorEstado>
);

export default TipoContribuyente;
